import * as types from "./actionTypes";

// Fetch
export const fetchGracePolicyRequest = (unit_id) => ({
  type: types.FETCH_GRACE_POLICY_REQUEST,
  payload:{unit_id}
});

export const fetchGracePolicySuccess = (data) => ({
  type: types.FETCH_GRACE_POLICY_SUCCESS,
  payload: data,
});

export const fetchGracePolicyFailure = (error) => ({
  type: types.FETCH_GRACE_POLICY_FAILURE,
  payload: error,
});

// Save
export const saveGracePolicyRequest = (payload) => ({
  type: types.SAVE_GRACE_POLICY_REQUEST,
  payload,
});

export const saveGracePolicySuccess = (response) => ({
  type: types.SAVE_GRACE_POLICY_SUCCESS,
  payload: response,
});

export const saveGracePolicyFailure = (error) => ({
  type: types.SAVE_GRACE_POLICY_FAILURE,
  payload: error,
});

// Fetch Leave Policy
export const fetchLeavePolicyRequest = (unit_id) => ({
  type: types.FETCH_LEAVE_POLICY_REQUEST,
  payload: { unit_id },
});

// Save Leave Policy
export const saveLeavePolicyRequest = (payload) => ({
  type: types.SAVE_LEAVE_POLICY_REQUEST,
  payload,
});